import React, { useState, useEffect } from 'react';
import { Img } from 'react-image';

import { useTranslation } from 'react-i18next';

import {
  Button, CircularProgress, Box, Grid, Typography,
} from '@material-ui/core';
import { uniqueId, isEmpty } from 'lodash';
import { makeStyles } from '@material-ui/core/styles';
import Hidden from '@material-ui/core/Hidden';
import moment from 'moment';
import 'moment/locale/th';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

import { styles } from '../style';

const useStyles = makeStyles(styles);

export default function Rain24DataLists() {
  const { t } = useTranslation();
  const classes = useStyles();

  const [isLoading, setLoading] = useState(false);
  const [hasError, sethasError] = useState();
  const [isOpen, setIsOpen] = useState(false);

  const hostApi = `${process.env.REACT_APP_API_URL}`;
  const placeHolder = 'https://via.placeholder.com/322x230?text=No%20Image&italic=true';
  const [radarSat] = useState('https://live1.hii.or.th/product/latest/radar/plot/composite_radar.png');
  const [photoIndex, setphotoIndex] = useState();
  const [radar, setRadar] = useState([]);
  const arrayImage = [{
    src: radarSat,
    title: 'Himawari Satellite IR',
    caption: '-',
  }];

  useEffect(() => {
    function getData() {
      setLoading(true);
      fetch(`${hostApi}/analyst/radar_img`)
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('Something went wrong ...');
        })
        .then((data) => {
          setRadar([...data.data]);
          setLoading(false);
        })
        .catch(() => { sethasError(true); });
    }
    getData();
  }, [hostApi]);

  return (
    <>
      {hasError && (
        <div>
          Error Occured
        </div>
      )}
      {isLoading && (
        <div className="Loading">
          <CircularProgress />
        </div>
      )}
      <div className={classes.root}>
        <Grid container spacing={2}>
          <Grid item sm={12} md={5}>
            <Box align="center">
              <Button onClick={() => { setIsOpen(true); setphotoIndex(0); }} id="radar_main">
                <Img
                  src={radarSat}
                  alt="Himawari Satellite IR"
                  className={classes.img}
                  unloader={(
                    <Img src={placeHolder} alt={t('ไม่มีข้อมูล')} className={classes.img} />
                  )}
                />
              </Button>
            </Box>
          </Grid>
          <Grid item sm={12} md={7}>
            <Grid container spacing={2}>
              {radar.map((img, i) => {
                const diff = moment().diff(moment(img.media_datetime), 'hours');
                arrayImage.push({
                  src: `${hostApi}/shared/image?_csrf=&image=${img.media_path}`,
                  title: `${img.radar_name}`,
                  caption: `${moment(img.media_datetime).format('ll')}`,
                });
                return (
                  diff > 72 || isEmpty(img.media_datetime) ? (
                    <Grid item xs={6} sm={3} md={3} key={uniqueId()}>
                      <Box display="block" align="center" key={uniqueId()}>
                        <Button onClick={() => { setIsOpen(true); setphotoIndex(i + 1); }} id={`radar_${i}`}>
                          <Img
                            src={`${hostApi}/shared/image?_csrf=&image=${img.media_path_thumb}`}
                            alt={img.media_datetime}
                            className={classes.img}
                            unloader={(
                              <Img src={placeHolder} alt={t('ไม่มีข้อมูล')} className={classes.img} />
                            )}
                          />
                        </Button>
                        <Typography variant="body2" className={classes.ertitle}>
                          {img.radar_name}
                        </Typography>
                        <Typography variant="caption" className={classes.ertime}>
                          <Hidden only="xs">
                            {t('ล่าสุด')}
                            {' '}
                          </Hidden>
                          {isEmpty(img.media_datetime) ? '-' : moment(img.media_datetime).format('ll')}
                        </Typography>
                      </Box>
                    </Grid>
                  )
                    : (
                      <Grid item xs={6} sm={3} md={3} key={uniqueId()}>
                        <Box display="block" align="center" key={uniqueId()}>
                          <Button onClick={() => { setIsOpen(true); setphotoIndex(i + 1); }} id={`radar_${i}`}>
                            <Img
                              src={`${hostApi}/shared/image?_csrf=&image=${img.media_path_thumb}`}
                              alt={img.media_datetime}
                              className={classes.img}
                              unloader={(
                                <Img src={placeHolder} alt={t('ไม่มีข้อมูล')} className={classes.img} />
                              )}
                            />
                          </Button>
                          <Typography variant="body2" className={classes.title}>
                            {img.radar_name}
                          </Typography>
                          <Typography variant="caption" className={classes.time}>
                            <Hidden only="xs">
                              {t('ล่าสุด')}
                              {' '}
                            </Hidden>
                            {moment(img.media_datetime).format('ll')}
                          </Typography>
                        </Box>
                      </Grid>
                    ));
              })}
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={12} align="right">
            {t('ข้อมูลจากกรมอุตุนิยมวิทยา, กรมฝนหลวงการบินและการเกษตร, สำนักระบายน้ำ กรุงเทพมหานคร')}
          </Grid>
        </Grid>
      </div>
      {
        isEmpty(arrayImage[photoIndex]) === false && isOpen && (
          <Lightbox
            mainSrc={arrayImage[photoIndex].src}
            nextSrc={arrayImage[(photoIndex + 1) % arrayImage.length].src}
            prevSrc={arrayImage[(photoIndex + arrayImage.length - 1) % arrayImage.length].src}
            imageTitle={arrayImage[photoIndex].title}
            imageCaption={arrayImage[photoIndex].caption}
            onCloseRequest={() => { setIsOpen(false); setphotoIndex(1); }}
            onMovePrevRequest={() => {
              setphotoIndex((photoIndex + arrayImage.length - 1) % arrayImage.length);
            }}
            onMoveNextRequest={() => setphotoIndex((photoIndex + 1) % arrayImage.length)}
            reactModalStyle={{
              overlay: { zIndex: '10000000' },
            }}
          />
        )
      }
    </>
  );
}
